import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import {connect} from 'react-redux';

import Api from '../../../util/api/Api';
import {Time, Config} from '../../../util';

import Select from '../../../components/select';
import Input from '../../../components/input';
import DatePicker from '../../../components/datepicker';
import TimeList from '../../../components/timelist';


class HeaderContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            chSelected: '',
            isVisable: false,
            chList: [],
            
        };

        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.renderChannelList = this.renderChannelList.bind(this);
        this.changeSelecBoxVisable = this.changeSelecBoxVisable.bind(this);
        this.ulClassName = this.ulClassName.bind(this);
        this.selectedOption = this.selectedOption.bind(this);
    }
    componentDidMount() {
        this.getChList();
      }
      
    async getChList () {
        try{
            const {changeChId} = this.props;
            if(!sessionStorage.getItem('chList')){
                const result = await Api.GetChList({chNo: ''}); 
                const useChList = result.files.ch.filter(ch => ch.use === 'Y');
                const chList = _.keyBy(useChList, 'chName');
                sessionStorage.setItem('chList', JSON.stringify(chList));
            }
            
            const chListObj = JSON.parse(sessionStorage.getItem('chList'));
            await this.setState({
                chList: chListObj,
                chSelected: Object.keys(chListObj)[0]
            });
            await changeChId(Object.keys(chListObj)[0].chId);
        } catch(e) {
            console.log(e);
        }
    }

    changeSelecBoxVisable(){
        this.setState( prevState => ({
            isVisable: !prevState.isVisable
            })
        )
    }

    async selectedOption(chSelected, chIdSelected){
        const {changeChId} = this.props;
        await this.setState({
            chSelected
        });
        await changeChId(chIdSelected);
        
    }
    renderChannelList(){
        const {chList} = this.state;
        const chImgList = _.chain(chList)
                .mapValues()
                .values()
                .map(ch => {
                const imgWhite = _.keyBy(Config.logoUrl, 'title')[ch.chName] && _.keyBy(Config.logoUrl, 'title')[ch.chName].imgWhite;
                return (
                    <li key={ch.chId} onClick={e =>this.selectedOption(ch.chName, ch.chId)}>
                        <i> <img src={imgWhite} alt={ch.chName} /></i>
                    </li>
                );
            }).value();
        return chImgList;
    }
    
    ulClassName(){
        const {isVisable} = this.state;
        return classnames({'show': isVisable}, {'hide': !isVisable});
    }
    handleOnSubmit(){
        const {getEpgInfo, selectedDate} = this.props;
        getEpgInfo(selectedDate);
    }
    render() {
        const {chSelected} = this.state;
        const {
            onStart,
            onStop,
            keyword,
            test,
            handleOnKeywordChange,
            handleSsomSelect,
            handleSeomSelect,
            handleOnSubmit
        } = this.props;
        return (
            <div className="container filter search">
                <div className='select-container schedule-text'>
                    <div className="element" onClick={this.changeSelecBoxVisable}>
                    {chSelected}
                    <span className="icon icon-select-down"></span>
                        <ul className={this.ulClassName()}>
                            {this.renderChannelList()}
                        </ul>
                    </div>
                </div>
                <TimeList.Range
                    onStart={onStart}
                    onStop={onStop}
                    valueType="msec"
                    onStartSelectTime={handleSsomSelect}
                    onStopSelectTime={handleSeomSelect}
                />
                <Input.Search keyword={keyword}
                    onChange={handleOnKeywordChange}
                    onSubmit={this.handleOnSubmit}/>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
      selectedDate: state.selectedDate,
    }
  };
  
HeaderContainer = connect(mapStateToProps)(HeaderContainer);


export default HeaderContainer;


// WEBPACK FOOTER //
// ./src/containers/schedule/TextMode/HeaderContainer.js